import React, { useContext } from 'react'
import './UserImageModal.scss'

import { modalContext } from 'global/context/sub-contexts/modalContext'
import { userContext } from 'global/context/sub-contexts/userContext'

import { updateProfile } from 'services/user'
import Avatars from './Avatars'

const UserImageModal = () => {
  const modal_context = useContext(modalContext)
  const user_context = useContext(userContext)
  const { toggleModal } = modal_context || {}

  const handleUserImageSelection = function (r) {
    let avatarURL = Avatars[r.target.attributes.data.value].file // a little sloppy, but instead of passing gatsby-"incorrect" static path, pass the filename

    updateProfile({ profileImageUrl: avatarURL }).then(function (response) {
      if (response.success) {
        //Note - pending api change to update user state
        user_context.setProfile(response.detail.user)
        toggleModal('off')
      } else {
        console.log('Problem changing avatar')
      }
    })
  }

  return (
    <div className="modal-user-image">
      <div className="modal-header">
        <span className="modal-header-expiry"></span>
      </div>
      <div className="content-body">
        <p>Select an avatar</p>

        <div class="user-image-avatar-selection row">
          {Avatars.map((avatar, index) => (
            <div class="user-avatar-option">
              <img
                data={index}
                key={index}
                src={avatar.file}
                onClick={handleUserImageSelection}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default UserImageModal
